<template>
    <bq-color-page
        :nav-hidden="true"
    >
        <div class="interaction-error__message mt-5">
            {{ errorMessages[interactionError.errorKey] }}
        </div>
    </bq-color-page>
</template>
<script>
import bqColorPage from '@/components/ui/bqColorPage'

import { mapGetters } from 'vuex'
export default {
    name: 'InteractionErrorContainer',
    components: {
        'bq-color-page': bqColorPage
    },
    data() {
        return {
            errorMessages: {
                "error.interaction.expired": this.$t('INTERACTION_BASE_INTERACTION_LINK_EXPIRED'),
                "error.interaction.notFound": this.$t('INTERACTION_BASE_INTERACTION_NOT_FOUND')
            }
        }
    },
    computed: {
        ...mapGetters([
            'interactionError'
        ])
    }
}
</script>
<style lang="scss">
.interaction-error__message {
    font-size: 1.35rem;
}
</style>